import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, map, throwError } from 'rxjs';
import { BadgeCountService } from '../layout/service/badge-count.service';
import { BadgeMenuItemKey, IBadgeCountResponse } from '../layout/interface/badge-count.interface';

@Injectable()
export class MockBadgeCountInterceptor implements HttpInterceptor {
  constructor(private badgeCountService: BadgeCountService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isDualApprovalRequest = request.url === this.badgeCountService.dualApprovalUrl;
    const isDecisionedRequest = request.url === this.badgeCountService.decisionedUrl;
    if (request.method !== 'POST' || (!isDualApprovalRequest && !isDecisionedRequest)) {
      return next.handle(request);
    }

    const expectedKeys: BadgeMenuItemKey[] = isDualApprovalRequest
      ? ['fednow-dualapproval', 'rtp-dualapproval']
      : ['fednow-ct', 'fednow-rfp-received', 'rtp-ct'];
    const body = request.body;
    if (
      typeof body !== 'object' ||
      body === null ||
      !('menuItems' in body) ||
      !Array.isArray(body.menuItems) ||
      !body.menuItems.every(key => expectedKeys.includes(key as BadgeMenuItemKey))
    ) {
      return throwError(
        () =>
          new HttpErrorResponse({
            status: 400,
            statusText: 'Invalid BadgeCount menuItems for endpoint',
            url: request.url,
          })
      );
    }

    const menuItems: BadgeMenuItemKey[] = body.menuItems;
    const fixtureRequest = request.clone({
      method: 'GET',
      url: 'assets/mocks/menu/badge-counts.json',
      body: null,
    });

    return next.handle(fixtureRequest).pipe(
      map(event => {
        if (!(event instanceof HttpResponse)) {
          return event;
        }

        const fixture: IBadgeCountResponse = event.body;
        const counts: IBadgeCountResponse['counts'] = {};
        for (const key of menuItems) {
          if (fixture.counts[key] === undefined) {
            throw new HttpErrorResponse({
              status: 500,
              statusText: `Missing mock badge count for ${key}`,
              url: request.url,
            });
          }

          counts[key] = fixture.counts[key];
        }

        return event.clone({ body: { counts }, url: request.url });
      })
    );
  }
}
